import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
/** Details for claimed authentication. */
export function VerifiedDetails() {
    return (_jsxs(Text.Paragraph, { children: ["The ", _jsx("strong", { children: "Programmatically user authentication" }), " configuration below is required. An icon is displayed in the agent interface to indicate that the user has been automatically authenticated by the system."] }));
}
